import { Box, BoxProps, useTheme } from '@mui/material';

export default function HeaderLogo<T extends React.ElementType = 'div'>(
  props: Partial<BoxProps<T>>
) {
  const theme = useTheme();

  return (
    <Box
      {...props}
      sx={{
        // background: 'linear-gradient(to bottom, #2c2041, #170330)',
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'max(min(80px, d5vh), 30px)',
        py: 3,
        ...(props.sx || {}),
      }}
    >
      <img
        src={
          theme.palette.mode === 'dark'
            ? '/white_fieldvest_logo.svg'
            : '/dark_fieldvest_logo.svg'
        }
        alt="Fieldvest Logo"
        style={{ width: 'max(min(140px, 20vw), 60px)' }}
      />
    </Box>
  );
}
